import { useMutation, useQueryClient } from '@tanstack/react-query';
import { recallReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import { RecallReportDetail } from '@/types';
import { CreateItemPayload } from '@/services/recall-report/recall-report-service';
import { logger } from '@/utils/logger';

interface UpdateItemsPayload {
  reportId: number;
  items: Array<{ id: number; quantity: number; is_deleted?: boolean; counterparty_product_id?: string }>;
  creates?: CreateItemPayload[];
}

type UpdateItemsOptions = {
  onSuccess?: (data: RecallReportDetail) => void;
  onError?: (error: Error) => void;
};

export const useUpdateRecallReportItems = (options?: UpdateItemsOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, items, creates }: UpdateItemsPayload) =>
      recallReportService.updateItems(reportId, items, creates ?? []),
    onSuccess: async (data, { reportId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.recallReport.detail(reportId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.recallReport.list() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      logger.error('Failed to update recall report items:', error);
      options?.onError?.(error);
    },
  });
};
